import { setShouldFireAutoFocusAnalyticEvent } from './set-should-fire-auto-focus-analytic-event';
import { setTriggerReason } from './set-trigger-reason';
import { toggleKeepIccOpen } from './toggle-keep-icc-open';

export const actions = {
	toggleKeepIccOpen,
	setShouldFireAutoFocusAnalyticEvent,
	setTriggerReason,
} as const;
